<template>
  <div class="legal-page white-theme">
    <div class="container">
      <div class="legal-header text-center">
        <h1>{{ $t('privacy.title') }}</h1>
        <p class="text-muted">{{ $t('privacy.lastUpdated') }}</p>
      </div>
      <div class="legal-content">
        <section v-for="(section, idx) in sections" :key="idx">
          <h2>{{ $t(`privacy.sections.${idx}.title`) }}</h2>
          <p v-for="(p, pi) in section.paragraphs" :key="pi">{{ $t(`privacy.sections.${idx}.paragraphs.${pi}`) }}</p>
        </section>
      </div>
      <div class="legal-nav">
        <router-link to="/terms" class="btn btn-secondary">{{ $t('privacy.navTerms') }}</router-link>
        <router-link to="/trust-safety" class="btn btn-secondary">{{ $t('privacy.navTrust') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  computed: {
    sections() {
      return this.$t('privacy.sections')
    }
  }
}
</script>

<style scoped>
.legal-page { padding: 48px 0 80px; }
.legal-header { margin-bottom: 48px; }
.legal-header h1 { font-size: 36px; font-weight: 800; margin-bottom: 8px; }
.legal-content { max-width: 800px; margin: 0 auto; }
.legal-content section { margin-bottom: 32px; }
.legal-content h2 { font-size: 20px; font-weight: 700; margin-bottom: 12px; }
.legal-content p { font-size: 15px; color: var(--text-secondary); line-height: 1.8; margin-bottom: 12px; }
.legal-nav { display: flex; gap: 12px; justify-content: center; margin-top: 48px; }
</style>
